import { useViewportSizeInPixels } from '@/hooks/use-viewport-size-in-pixels'
import { ChatBreakpoints } from '@/chat-common/chat-layout-constants'

/** Whether the viewport is at or below ChatBreakpoints.SMALL. */
export function useIsSmallChatBreakpoint(): boolean {
  return useViewportSizeInPixels().width <= ChatBreakpoints.SMALL
}
